<template>
  <div>
    <sweet-modal ref="notify" icon="success">
      <div style="margin-bottom: 2vh;">Adresa de email a fost verificată!</div>

      <div>
        <button type="button" class="buton btn" @click="goToLogin()">Ok</button>
      </div>
    </sweet-modal>
  </div>
</template>

<script>

import axios from 'axios'
import {SweetModal} from 'sweet-modal-vue'

export default {

  components: {
    SweetModal
  },

  created() {
    axios.post('auth/confirm_mail', {
      confirmation_code: this.$route.params.code
    }).then(() => {
      this.$refs.notify.open()
    }).catch((e) => {
      console.log(e)
      alert('Ceva nu a mers bine.')
    })
  },

  methods: {
    goToLogin(){
      this.$router.replace({ name: 'login' })
    }
  }
}
</script>
